export default __webpack_public_path__ + "static/media/profile_Icon.2b5f2b0a.png";